<div class="container">
  <div *ngIf="filterEditMode">
    <by-id-form
      *ngIf="filterCurrentCode === 'by.id'"
      [filter]="selectedFilter"
      (applyFilter)="onApplyFilter($event)"
    ></by-id-form>

    <by-new-west-form
      *ngIf="filterCurrentCode === 'newest'"
      (applyFilter)="onApplyFilter($event)"
    ></by-new-west-form>

    <by-title-form
      *ngIf="filterCurrentCode === 'by.title'"
      (applyFilter)="onApplyFilter($event)"
    ></by-title-form>

    <by-status-form
      *ngIf="filterCurrentCode === 'by.status'"
      (applyFilter)="onApplyFilter($event)"
    ></by-status-form>

    <by-branch-form
      *ngIf="filterCurrentCode === 'by.branch'"
      (applyFilter)="onApplyFilter($event)"
    ></by-branch-form>

    <by-department-form
      *ngIf="filterCurrentCode === 'by.department'"
      (applyFilter)="onApplyFilter($event)"
    ></by-department-form>

    <by-priority-form
      *ngIf="filterCurrentCode === 'by.priority'"
      (applyFilter)="onApplyFilter($event)"
    ></by-priority-form>

    <by-assigned-form
      *ngIf="filterCurrentCode === 'by.assigned'"
      (applyFilter)="onApplyFilter($event)"
    ></by-assigned-form>
    <by-registered-form
      *ngIf="filterCurrentCode === 'by.registered'"
      (applyFilter)="onApplyFilter($event)"
    ></by-registered-form>
    <active-form
      *ngIf="filterCurrentCode === 'active'"
      (applyFilter)="onApplyFilter($event)"
    >
    </active-form>
    <archived-form
      *ngIf="filterCurrentCode === 'archived'"
      (applyFilter)="onApplyFilter($event)"
    >
    </archived-form>
  </div>
</div>
